import { useState } from "react";
import "../../sass/signage.sass"
import ajax from '../../common/components/ajax.jsx'
import Constants from '../../common/components/constants.jsx'
import Dialog from '@mui/material/Dialog/Dialog.js'
import DialogContent from '@mui/material/DialogContent/DialogContent.js'
import { DialogTitle } from '@mui/material'
import { DialogActions } from '@mui/material'
import { DialogContentText } from '@mui/material'
import { Button } from "@mui/material";

const UserLogout =(props)=>{
    const { auth } = props
    const [logoutModalIsOpen, setLogoutModalIsOpen] = useState(false)
    const [alertModalIsOpen, setAlertModalIsOpen] = useState(false)
    const [logoutFailed, setLogoutFailed] = useState(false)
    const [alertBody, setAlertBody] = useState("")

    const toggleAlertModal=()=> {
        // サインアウトに失敗した場合、アラートを閉じたときにスーパーリロードする
        if(logoutFailed) document.location.reload(true);
        setAlertModalIsOpen(alertModalIsOpen)
    }
    /**
     * サインアウトAPIと通信し、成功した場合はサインアウトする
     */
    const doLogout=()=>{
        ajax.post(
            Constants.URLs.LOGOUT,
            null,
            (successJson) => {
                if(successJson.hasOwnProperty('LOGGED_IN') && successJson.LOGGED_IN){
                    setLogoutFailed(true)
                    setAlertBody('サインアウトに失敗しました。ページを再読み込みします')
                    setAlertModalIsOpen(true)
                    return;
                }

                auth.onLoginStatusChange(false);
                setLogoutModalIsOpen(!logoutModalIsOpen)
                document.location.href = '/login';
            },
            (errorJson) => {
                setLogoutModalIsOpen(!logoutModalIsOpen)
            }
        );
    }

    return(
        <div>
            <div 
             className="logout_button" 
             onClick={() => { setLogoutModalIsOpen(!logoutModalIsOpen) }}
            >サインアウト</div>

            <Dialog
             open={alertModalIsOpen}
             onClose={() => toggleAlertModal()}
             aria-labelledby="alert-modal-title"
             maxWidth={"sm"}
             fullWidth={true}
            >
                <DialogTitle id="alert-modal-title">Alert</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {alertBody}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => toggleAlertModal()}>
                        閉じる
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
             open={logoutModalIsOpen}
             onClose={() => setLogoutModalIsOpen(!logoutModalIsOpen)}
             aria-labelledby="alert-modal-title"
             maxWidth={"sm"}
             fullWidth={true}
            >
                <DialogTitle id="alert-modal-title">サインアウト</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        サインアウトします。よろしいですか？
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setLogoutModalIsOpen(!logoutModalIsOpen)}>
                        キャンセル
                    </Button>
                    <Button
                        color="error"
                        onClick={() => doLogout()}
                    >
                        サインアウト
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default UserLogout